export const areArraysEqual = (arr1: string[] = [], arr2: string[] = []): boolean => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  if (arr1.length === 0) {
    return true;
  }

  const set = new Set<string>(arr1);
  return arr2.every((item) => set.has(item));
};
